"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./NumericStepper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NumericStepper = function NumericStepper(_ref) {
  var title = _ref.title,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      min = _ref.min,
      max = _ref.max;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var limitedValue = function limitedValue(val) {
    if (min != null && val < min) {
      return onChange(min);
    }

    if (max != null && val > max) {
      return onChange(max);
    }

    return onChange(val);
  };

  var changeHandler = function changeHandler(e) {
    if (e.target.value) {
      var val = parseInt(e.target.value, 10);
      if (isNaN(val)) return; // setShowHour(val <= 2 ? val : null);

      limitedValue(val);
    } else {
      // setShowHour(0);
      limitedValue(value != null ? value : 0);
    }
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 38) {
      //Arrow Up
      limitedValue(value + 1);
      e.preventDefault();
    } else if (e.keyCode === 40) {
      //Arrow Down
      limitedValue(value - 1);
      e.preventDefault();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-numeric-stepper' + (focused ? ' focused' : '') + (error ? ' error' : '')
  }, title && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-ns-label"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ns-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ns-input-container"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    pattern: "[0-9]*",
    className: "gcl-ns-input",
    value: value,
    onChange: changeHandler,
    onKeyDown: onKeyDown,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", null, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ns-buttons"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-up",
    tabIndex: -1,
    onClick: function onClick() {
      return limitedValue(value + 1);
    },
    onMouseDown: function onMouseDown() {
      return setFocused(true);
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron",
    tabIndex: -1,
    onClick: function onClick() {
      return limitedValue(value - 1);
    },
    onMouseDown: function onMouseDown() {
      return setFocused(true);
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    }
  }))));
};

NumericStepper.propTypes = {
  title: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number
};
var _default = NumericStepper;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/NumericStepper/NumericStepper.js
// module id = 1910
// module chunks = 0